import { useTranslation } from 'react-i18next';
import domstolLogo from 'src/assets/images/DA_NorgesDomstoler_Negativ_RGB.svg';
import { Colors } from '../Tokens/colors';

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <div
      className="mt-auto flex"
      style={{ backgroundColor: Colors.DdsColorPrimaryBase }}
    >
      <footer
        className="mx-4 flex min-h-40 flex-1 flex-col gap-4 pt-12 sm:mx-8 md:mx-16 lg:mx-24 lg:flex-row lg:gap-10 xl:mx-40 xl:gap-20"
        style={{ backgroundColor: Colors.DdsColorPrimaryBase }}
      >
        <div className="flex h-[100px] w-[188px] pt-[6px]">
          <img src={`${domstolLogo}`} alt={t('logo.alt.text')} />
        </div>
        <div className="flex flex-col text-white lg:ml-auto">
          <h2 className="text-sm font-semibold">{t('footer.name.heading')}</h2>
          <p>{t('footer.organization.number')}</p>
          <p>{t('footer.postal.address.line.1')}</p>
          <p>{t('footer.postal.address.line.2')}</p>
        </div>
        <div className="flex flex-col text-white">
          <h2 className="text-sm font-semibold">
            {t('footer.contact.heading')}
          </h2>
          <p>{t('footer.phone')}</p>
          <a
            href={`mailto:${t('footer.mail')}`}
            className="text-white underline"
          >
            {t('footer.mail')}
          </a>
          <p>{t('footer.visiting.address.line.1')}</p>
          <p>{t('footer.visiting.address.line.2')}</p>
        </div>
        <div className="flex flex-col text-white">
          <h2 className="text-sm font-semibold">{t('footer.links.heading')}</h2>
          <a
            href="https://www.domstol.no/contentassets/1ce8669047b14ba188baa94b630bf0a3/handbok-portal-for-meddommerutvalg-2024.pdf"
            target="_blank"
            rel="noreferrer"
            className="text-white underline"
          >
            {t('footer.links.user.manual')}
          </a>
          <a
            href="https://www.domstol.no/no/personvernpolicy/"
            target="_blank"
            rel="noreferrer"
            className="text-white underline"
          >
            {t('footer.links.privacy.cookie.notice')}
          </a>
          <a
            href="https://uustatus.no/nb/erklaringer/publisert/dfaf062b-0514-4f94-b211-62ce6c1e7c76"
            target="_blank"
            rel="noreferrer"
            className="text-white underline"
          >
            {t('footer.links.accessibility.notice')}
          </a>
        </div>
      </footer>
    </div>
  );
};
